import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAngleLightLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m19.198 19.018 13.61-13.403a1.388 1.388 0 0 1 1.964 0l.82.82a1.388 1.388 0 0 1 0 1.965L23.774 20l11.808 11.6a1.388 1.388 0 0 1 0 1.964l-.82.82a1.388 1.388 0 0 1-1.964 0l-13.61-13.402a1.398 1.398 0 0 1 .01-1.964Zm-14.79 1.964L18.02 34.385a1.388 1.388 0 0 0 1.964 0l.82-.82a1.388 1.388 0 0 0 0-1.965L8.985 20 20.792 8.4a1.388 1.388 0 0 0 0-1.964l-.82-.82a1.388 1.388 0 0 0-1.964 0L4.398 19.017a1.398 1.398 0 0 0 .01 1.964Z" })
});
export default SvgAngleLightLeft;
